import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import {
  ArrowDown,
  ArrowUp,
  Users,
  ChatCircleText,
  Calendar,
} from "@phosphor-icons/react";

function Stat({ icon: Icon, label, value, accent }) {
  return (
    <div className="rounded-xl border border-[var(--border)] bg-[var(--surface)] p-4">
      <div className="flex items-center gap-2 text-[var(--muted)]">
        <Icon size={14} />
        <span className="text-[11px] tracking-wider uppercase">{label}</span>
      </div>
      <div className={`heading text-2xl font-bold mt-2 ${accent || ""}`}>{value ?? "—"}</div>
    </div>
  );
}

export default function StatsDialog({ open, onClose }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!open) return;
    api.get("/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="stats-dialog">
        <DialogHeader>
          <DialogTitle className="heading">Today's activity</DialogTitle>
          <DialogDescription>Quick team pulse — resets daily (UTC).</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <Stat icon={ArrowDown} label="Incoming today" value={stats?.today_inbound} accent="text-[#10B981]" />
          <Stat icon={ArrowUp} label="Outgoing today" value={stats?.today_outbound} accent="text-[#3B82F6]" />
          <Stat icon={Users} label="Unique drivers" value={stats?.today_unique_drivers} />
          <Stat icon={ChatCircleText} label="Total today" value={stats?.today_total} />
          <div className="col-span-2">
            <Stat icon={Calendar} label="All-time messages" value={stats?.all_time_total} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
